import Headroom from 'headroom.js';
import { breakpoints } from './breakpoints';

export default function navigation() {
  /**
   * Headroom header
   */
  if ($('.site-header').length) {
    const headroom = new Headroom(document.querySelector('.site-header'), {
      offset: 50,
    });
    headroom.init();
  }

  /**
   * Mobile navigation
   */
  const $nav = $('.nav-mobile');

  $nav.find('.menu-item, .social').each(function (index, value) {
    $(this).addClass('menu-item-animated menu-item-animated--' + index);
  });

  $('.nav-mobile-toggle').click(function (e) {
    e.preventDefault();

    $('body').toggleClass('navbar--opened');

    if (!$('body').hasClass('navbar--opened')) {
      $('body').addClass('navbar--closing');
      setTimeout(function () {
        $('body').removeClass('navbar--closing');
      }, 600);
    }
  });

  /**
   * Bouton 'Visite virtuelle' sur la page de contact
   */
  const $virtualVisitLink = $('.page.contact .menu-item.virtual-visit a, .page.contact-us .menu-item.virtual-visit a');
  $virtualVisitLink.addClass('no-ajaxify');
  $virtualVisitLink.click(function (e) {
    e.preventDefault();

    let delay = 0;

    //Close mobile menu if need be
    if ($(this).closest('.nav-mobile').length) {
      $('.nav-mobile__close .nav-mobile-toggle').click();
      delay = 600;
    }

    //Scroll to form
    setTimeout(function () {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $('#rendezvous').offset().top,
        },
        1000
      );
    }, delay);
  });
}
